import { common } from '../../classes/common';
import { lang } from '../../resources/lang';

import { thumbArea as viewerThumbArea } from './thumbArea';

import { viewerService } from '../../classes/viewer/viewerService';

import { notify } from '../../classes/notify';
import { utils } from '../../utils';

export const workArea = {

  idDOM: '#work-area-view-center',

  viewMarcacao: true,

  element: function () {

    return jQuery(workArea.idDOM);
  },

  clear: function () {

    workArea.element().empty();

  },

  loading: function () {

    workArea.clear();
    workArea.element().append(common.loading.element());

  },

  hide: function () {

    workArea.element().hide();

  },

  show: function () {

    workArea.element().show();

  },

  resize: function () {

    workArea.viewerPage.resize();

  },

  toolbarPage: {

    classDOM: '.liquid-page-tools',

    element: function () {

      return jQuery(workArea.toolbarPage.classDOM);

    },

    hide: function () {

      workArea.toolbarPage.element().hide();

    },

    show: function () {

      workArea.toolbarPage.element().show();

    },

    sizeTool: {

      classDOM: '.page-tools-left-1',

      element: function () {

        return jQuery(workArea.toolbarPage.sizeTool.classDOM);

      },

      hide: function () {

        workArea.toolbarPage.sizeTool.element().hide();

      },

      show: function () {

        workArea.toolbarPage.sizeTool.element().show();

      },

      create: function () {

        var $element = $('<div class="page-tools-left-1"></div>');

        var $tool_fullscreen = $('<i class="material-icons" style="font-size: 30px; vertical-align: sub;">&#xE5D0;</i>');
        $tool_fullscreen.on('click', function () {

          workArea.viewerPage.element().find('img').css('width', '');
          workArea.viewerPage.element().find('img').css('height', '');
          workArea.toolbarPage.sizeTool.element().find('select').val(100);

        });

        var $tool_zoom_in = $('<i class="material-icons">&#xE148;</i>');
        $tool_zoom_in.on('click', function () {

          var $imgElement = workArea.viewerPage.element().find('img');
          var actualHeight = $imgElement.height();

          var imageHeight = $imgElement[0].naturalHeight;
          var factor = imageHeight / 10;
          factor = actualHeight + factor;

          $imgElement.css('width', '');
          $imgElement.css('height', factor + 'px');
          $('.page-tools-left-2 select').val('4');
        });

        var $tool_zoom_out = $('<i class="material-icons">&#xE15D;</i>');
        $tool_zoom_out.on('click', function () {

          var $imgElement = workArea.viewerPage.element().find('img');
          var actualHeight = $imgElement.height();

          var imageHeight = $imgElement[0].naturalHeight;
          var factor = imageHeight / 10;
          factor = actualHeight - factor;
          if (factor <= 0) {
            factor = 0;
          }
          $imgElement.css('width', '');
          $imgElement.css('height', factor + 'px');
          $('.page-tools-left-2 select').val('4');
        });

        $element.append($tool_fullscreen);
        $element.append($tool_zoom_in);
        $element.append($tool_zoom_out);

        return $element;

      }

    },

    definedSizeTool: {

      classDOM: '.page-tools-left-2',

      element: function () {

        return jQuery(workArea.toolbarPage.definedSizeTool.classDOM);

      },

      hide: function () {

        workArea.toolbarPage.definedSizeTool.element().hide();

      },

      show: function () {

        workArea.toolbarPage.definedSizeTool.element().show();

      },

      create: function () {

        var $element = $('<div class="page-tools-left-2"></div>');
        var $div_input_text = $('<div class="liquid-input-text"></div>');
        var $select_zoom = $('<select id="page_zoom_defined_size" style="color: #fff;"></select>');

        var optionItens = [
          { val: 3, text: 'Fit' },
          { val: 2, text: 'Horizontal' },
          { val: 1, text: 'Vertical' },
          { val: 4, text: 'Custom' }
        ];
        $(optionItens).each(function () {
          var $option = $("<option>").attr('value', this.val).text(this.text);
          if (this.val === 2) {
            $option.attr('selected', true);
          }
          $select_zoom.append($option);
        });
        $select_zoom.on('change', function () {

          var selectValue = parseInt($(this).val());
          var $image = workArea.viewerPage.element().find('img');

          if (selectValue === 3) {
            let imageTemp = new Image();
            imageTemp.src = $image.attr("src");
            let heightContainer = (workArea.viewerPage.element().height() - 20);
            let widthContainer = (workArea.viewerPage.element().width() - 20);
            let factor = (heightContainer / widthContainer);
            let factorImage = (imageTemp.height / imageTemp.width);
            if (factorImage >= factor) {
              $image.css('width', 'auto');
              var height = (workArea.viewerPage.element().height() - 20);
              $image.css('height', height + 'px');
            }
            else {
              $image.css('width', '100%');
              $image.css('height', 'auto');
            }
          }
          else if (selectValue === 2) {
            $image.css('width', '100%');
            $image.css('height', 'auto');
          }
          else if (selectValue === 1) {
            $image.css('width', 'auto');
            let height = (workArea.viewerPage.element().height() - 20);
            $image.css('height', height + 'px');
          }
        });
        $div_input_text.append($select_zoom);
        $element.append($div_input_text);
        return $element;

      }

    },

    navLabelTool: {

      classDOM: '.page-tools-left-3',

      element: function () {

        return jQuery(workArea.toolbarPage.navLabelTool.classDOM);

      },

      hide: function () {

        workArea.toolbarPage.navLabelTool.element().hide();

      },

      show: function () {

        workArea.toolbarPage.navLabelTool.element().show();

      },

      updateLabel: function (page, total) {

        workArea.toolbarPage.navLabelTool.element().find('.tool-nav-label').html(page + ' / ' + total);

      },

      create: function (page, total) {

        var $element = $('<div class="page-tools-left-3"></div>');
        var $div_nav = $('<div style="line-height: 2;"></div>');

        var $div_nav_left = $('<div class="tool-nav"></div>');
        $div_nav_left.append('<i class="fa fa-caret-left" aria-hidden="true"></i>');
        $div_nav_left.on('click', function () {

          var ordem = parseInt(viewerThumbArea.getElementSelected().attr('data-ordem'));

          if (ordem > 1) {

            ordem = ordem - 1;

            var $minSelect = viewerThumbArea.getElementByOrder((ordem));

            if ($minSelect.length > 0) {

              viewerThumbArea.setElementSelectedByOrder(ordem);

              viewerThumbArea.getElementThumbSelected().click();

            }
          }
        });
        $div_nav.append($div_nav_left);

        var $div_nav_label = $('<div class="tool-nav-label"></div>');
        $div_nav_label.html(page + ' / ' + total);
        $div_nav.append($div_nav_label);

        var $div_nav_right = $('<div class="tool-nav"></div>');
        $div_nav_right.append('<i class="fa fa-caret-right" aria-hidden="true"></i>');
        $div_nav_right.on('click', function () {

          var ordem = parseInt(viewerThumbArea.getElementSelected().attr('data-ordem'));

          if (ordem < total) {

            ordem = ordem + 1;

            var $minSelect = viewerThumbArea.getElementByOrder((ordem));

            if ($minSelect.length > 0) {

              viewerThumbArea.setElementSelectedByOrder(ordem);

              viewerThumbArea.getElementThumbSelected().click();

            }
          }
        });
        $div_nav.append($div_nav_right);

        $element.append($div_nav);

        return $element;

      },

      setMarginForArquivo: function () {
        workArea.toolbarPage.navLabelTool.element().css('margin-left', '40%');
      },

      clearMargin: function () {
        workArea.toolbarPage.navLabelTool.element().css('margin-left', '');
      }

    },

    printTool: {

      classDOM: '.page-tools-left-4',

      element: function () {

        return jQuery(workArea.toolbarPage.printTool.classDOM);

      },

      hide: function () {

        workArea.toolbarPage.printTool.element().hide();

      },

      show: function () {

        workArea.toolbarPage.printTool.element().show();

      },

      convertFileAsPDFAndPrint: function (pageId, ordemMultiPage) {

        var blobArrayObj =  workArea.viewerPage.getBlobArrayObject(pageId, ordemMultiPage);

        if (blobArrayObj !== null) {

          common.openLoadingFullPage();

          var extension = utils.getExtensionFromMimeType(blobArrayObj.blobObject.type);

          var formData = new FormData();
          var fileName = `arquivo.${extension}`;
          formData.append('file', blobArrayObj.blobObject, fileName);
          formData.append('token', window.lsViewerToken);

          viewerService.postConvertPageAsPDFFile(formData)
            .then((blob) => {

              console.log('version-202608311514 - convert and prinpdf');

              var URL = window.URL || window.webkitURL;
              var srcUrl = URL.createObjectURL(blob);

              workArea.toolbarPage.printTool.printBlobPDF(srcUrl);
              
              // var URL = window.URL || window.webkitURL;
              // var srcUrl = URL.createObjectURL(blob);

              // var oldFrame = document.getElementById('pdfjs-hidden-print-frame');
  
              // if (oldFrame) {
              //     oldFrame.remove();
              // }
    
              // var iframe = document.createElement('iframe');

              // const viewerUrl = utils.getPdfJsViewerUrl();
    
              // iframe.id = 'pdfjs-hidden-print-frame';
              // iframe.src = viewerUrl + '?file=' + encodeURIComponent(srcUrl);
              // iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:1px;height:1px;border:0;opacity:0;pointer-events:none;';
    
              // document.body.appendChild(iframe);
    
              // iframe.onload = function () {
              //     setTimeout(function () {
              //         iframe.contentWindow.postMessage({
              //             action: 'liquidsuite-print-pdf'
              //         }, window.location.origin);
              //     }, 1000);
              // };

              // notify.alert('Atenção', 'Você esta imprimindo o arquivo original no formato PDF. Para imprimir o arquivo original, realize o download do mesmo e imprima localmente!');

            }).catch((failData) => {

              let errorMessage = common.getErrorMessage(failData);

              common.closeLoadingFullPage();

              notify.danger('Atenção', `Não foi possível obter a versão deste arquivo em PDF apra impressão. <br> ${errorMessage}`);

            });
        } 
        else {
          notify.danger('Atenção', `Não é possível obter a versão deste arquivo em PDF apra impressão. <br> Este arquivo não pode ser impresso diretamente no browser <br> Para imprimir o arquivo, realize o download do mesmo e imprima localmente!`);
        }
        
      },

      prinArquivoAsPDF: function (pageId) {

        let blobArrayObject = workArea.viewerPage.getBlobArrayObject(pageId);

        if (blobArrayObject === null || blobArrayObject.isRangeAccess) {
          notify.danger('Atenção', `Não é possível obter a versão deste arquivo em PDF apra impressão. <br> Este arquivo não pode ser impresso diretamente no browser <br> Para imprimir o arquivo, realize o download do mesmo e imprima localmente!`);
          return;
        }

        if (window.lsViewerConfig && window.lsViewerConfig.showArquivosAsPDF) {

          workArea.toolbarPage.printTool.prinPDF();
          // if (window.lsViewerConfig.usePdfJs) {
            
          // }
          // var iframe = document.getElementById("pdfjsViewerFrame");
                    
          // if (!iframe || !iframe.contentWindow) {
          //     return;
          // }

          // iframe.contentWindow.postMessage({
          //     action: 'liquidsuite-print-pdf'
          // }, window.location.origin);

        }
        else {
          workArea.toolbarPage.printTool.convertFileAsPDFAndPrint(pageId, 1);
        }

      },

      prinPDF: function () {

        console.log('version-202608311514 - prinpdf');

        if (window.lsViewerConfig && window.lsViewerConfig.usePdfJs) {

          var iframe = document.getElementById("pdfjsViewerFrame");

          var url = new URL(iframe.src);

          var blobUrl = url.searchParams.get("file");

          workArea.toolbarPage.printTool.printBlobPDF(blobUrl);

          // var iframe = document.getElementById("pdfjsViewerFrame");
                    
          // if (!iframe || !iframe.contentWindow) {
          //     return;
          // }

          // iframe.contentWindow.postMessage({
          //     action: 'liquidsuite-print-pdf'
          // }, window.location.origin);

        }
        else {

          var embed = document.getElementById("embedViewerFrame");
          
          if (!embed || !embed.src) {
              return;
          }

          var srcUrl = embed.src;

          workArea.toolbarPage.printTool.printBlobPDF(srcUrl);

          // var embed = document.getElementById("embedViewerFrame");

          // if (!embed || !embed.src) {
          //     return;
          // }

          // var srcUrl = embed.src;
  
          // var oldFrame = document.getElementById('pdfjs-hidden-print-frame');

          // if (oldFrame) {
          //     oldFrame.remove();
          // }

          // var iframe = document.createElement('iframe');

          // const viewerUrl = utils.getPdfJsViewerUrl();

          // iframe.id = 'pdfjs-hidden-print-frame';
          // iframe.src = viewerUrl + '?file=' + encodeURIComponent(srcUrl);
          // iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:1px;height:1px;border:0;opacity:0;pointer-events:none;';

          // document.body.appendChild(iframe);

          // iframe.onload = function () {
          //     setTimeout(function () {
          //         iframe.contentWindow.postMessage({
          //             action: 'liquidsuite-print-pdf'
          //         }, window.location.origin);
          //     }, 1000);
          // };
        
        }

      },

      create: function () {

        var $left_tools_4 = $('<div class="page-tools-left-4"></div>');

        var $tool_print = $('<i class="material-icons" title="' + lang.print + '">&#xE8AD;</i>');
        $tool_print.on('click', function () {

          if (!workArea.canPrint()) {
            notify.alert('Atenção', 'Você não tem permissão para imprimir este arquivo!');
            return;
          }

          if (utils.isVSCodeElectronBrowser()) {
            notify.alert('Atenção', 'A impressão não é suportada no navegador integrado do VS Code. Abra no Chrome, Edge ou Firefox.');
            return;
          }

          let fileType = viewerThumbArea.getAtrribTypeElementSelected();
          let fileExtension = viewerThumbArea.getAtrribExtensionElementSelected();
          let pageId = viewerThumbArea.getAtrribPageIdElementSelected();
          let ordemMultiPage =  viewerThumbArea.getAtrribOrdemMultiPageElementSelected();

          if (fileType === 1) { // IMAGEM 
            const unsupportedPrintExtensions = new Set([
                5, 6, 9, 10
            ]);
            if (unsupportedPrintExtensions.has(fileExtension)) {
                notify.alert('Atenção', 'Este tipo de arquivo não pode ser impresso no navegador. Realize o download e imprima localmente!');
            }
            else {
              // IMPRIMIR COMO PDF
              workArea.toolbarPage.printTool.convertFileAsPDFAndPrint(pageId, ordemMultiPage);
            }
          }
          else if (fileType === 2) { // ARQUIVO
            const unsupportedPrintExtensions = new Set([
                6, 9, 10, 13, 14, 15, 18, 19, 20, 21, 22, 24, 25
            ]);
            if (unsupportedPrintExtensions.has(fileExtension)) {
                notify.alert('Atenção', 'Este tipo de arquivo não pode ser impresso no navegador!');
            }
            else {
              // IMPRIMIR COMO PDF
              if (fileExtension === 3) {
                workArea.toolbarPage.printTool.prinPDF();
              }
              else {
                workArea.toolbarPage.printTool.prinArquivoAsPDF(pageId);
              }
            }
          }
          else if (fileType === 3) { // MULTIMIDIA
            notify.alert('Atenção', 'Este tipo de arquivo não pode ser impresso no navegador!');
          }

        });
        $left_tools_4.append($tool_print);

        return $left_tools_4;

      },

      printBlobPDF: function (blobUrl) {
        var oldFrame = document.getElementById("pdf-native-print-frame");

        if (oldFrame) {
            oldFrame.remove();
        }

        var iframe = document.createElement("iframe");

        iframe.id = "pdf-native-print-frame";
        iframe.src = blobUrl;

        iframe.style.position = "fixed";
        iframe.style.left = "0";
        iframe.style.top = "0";
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        iframe.style.border = "0";
        iframe.style.opacity = "0";
        iframe.style.pointerEvents = "none";
        iframe.style.zIndex = "-1";

        iframe.onload = function () {

            var printWindow = iframe.contentWindow;

            var cleanup = function () {

                if (iframe.parentNode) {
                    iframe.parentNode.removeChild(iframe);
                }
            };

            printWindow.addEventListener("afterprint", cleanup, {
                once: true
            });

            try {

                printWindow.focus();
                printWindow.print();

            }
            catch (error) {

                cleanup();

                console.error("Erro ao imprimir PDF:", error);
            }
            finally {
              setTimeout(function () {
                common.closeLoadingFullPage();
              }, 1000);
            }
        };

        document.body.appendChild(iframe);
      }

    },

    downloadTool: {

      classDOM: '.page-tools-left-5',

      element: function () {

        return jQuery(workArea.toolbarPage.downloadTool.classDOM);

      },

      hide: function () {

        workArea.toolbarPage.downloadTool.element().hide();

      },

      show: function () {

        workArea.toolbarPage.downloadTool.element().show();

        // jQuery('.page-tools-left-5').show();

      },

      downloadImage: function (pageId, ordemMultiPage) {

        var blobArrayObj =  workArea.viewerPage.getBlobArrayObject(pageId, ordemMultiPage);

        if (blobArrayObj !== null) {
          var extension = utils.getExtensionFromMimeType(blobArrayObj.blobObject.type);
          var fileName = `liquid_viewer.${extension}`;

          let a = document.createElement("a");
          a.download = fileName;
          a.href = blobArrayObj.blob;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

        }
        else {
          notify.danger('Atenção', `Não foi possível obter o arquivo para download!`);
        }
        
      },

      downloadPDF: function () {

        if (window.lsViewerConfig && window.lsViewerConfig.usePdfJs) {

          var iframe = document.getElementById("pdfjsViewerFrame");

          var url = new URL(iframe.src);

          var blobUrl = url.searchParams.get("file");

          workArea.toolbarPage.downloadTool.downloadBlob(blobUrl);

          // var iframe = document.getElementById("pdfjsViewerFrame");
                    
          // if (!iframe || !iframe.contentWindow) {
          //     return;
          // }

          // iframe.contentWindow.postMessage({
          //     action: 'liquidsuite-download-pdf'
          // }, window.location.origin);

        }
        else {

          var embed = document.getElementById("embedViewerFrame");
          
          if (!embed || !embed.src) {
              return;
          }

          workArea.toolbarPage.downloadTool.downloadBlob(embed.src);

          // var embed = document.getElementById("embedViewerFrame");

          // if (!embed || !embed.src) {
          //     return;
          // }

          // var srcUrl = embed.src;
  
          // var oldFrame = document.getElementById('pdfjs-hidden-print-frame');

          // if (oldFrame) {
          //     oldFrame.remove();
          // }

          // var iframe = document.createElement('iframe');

          // const viewerUrl = utils.getPdfJsViewerUrl();

          // iframe.id = 'pdfjs-hidden-print-frame';
          // iframe.src = viewerUrl + '?file=' + encodeURIComponent(srcUrl);
          // iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:1px;height:1px;border:0;opacity:0;pointer-events:none;';

          // document.body.appendChild(iframe);

          // iframe.onload = function () {
          //     setTimeout(function () {
          //         iframe.contentWindow.postMessage({
          //             action: 'liquidsuite-download-pdf'
          //         }, window.location.origin);
          //     }, 1000);
          // };
        
        }
        
      },

      downloadOtherFile: function (pageId, ordemMultiPage, fileType, fileExtension) {

        var blobArrayObj =  workArea.viewerPage.getBlobArrayObject(pageId, ordemMultiPage);

        if (blobArrayObj !== null) {

          let mimeType = '';

          if (blobArrayObj.isRangeAccess) {
            if (fileType === 2) {
              mimeType = utils.getArquivoMimeTypeByExtensaoLiquidSuite(fileExtension);
            }
            else if (fileType === 3) {
              mimeType = utils.getMultimidiaMimeTypeByExtensaoLiquidSuite(fileExtension);
            }
          }
          else {
            mimeType = blobArrayObj.blobObject.type;
          }

          let extension = utils.getExtensionFromMimeType(mimeType);
          
          var fileName = `liquid_viewer.${extension}`;

          let a = document.createElement("a");
          a.download = fileName;
          a.href = blobArrayObj.blob;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

        }
        else {
          notify.danger('Atenção', `Não foi possível obter o arquivo para download!`);
        }    
      },

      create: function () {

        var $left_tools_5 = $('<div class="page-tools-left-5"></div>');

        var $tool_download = $('<i class="material-icons" title="' + lang.download + '">&#xE2C4;</i>');
        $tool_download.on('click', function () {

          if (!workArea.canDownload()) {
            notify.alert('Atenção', 'Você não tem permissão para realizar o download este arquivo!');
            return;
          }

          let fileType = viewerThumbArea.getAtrribTypeElementSelected();
          let fileExtension = viewerThumbArea.getAtrribExtensionElementSelected();
          let pageId = viewerThumbArea.getAtrribPageIdElementSelected();
          let ordemMultiPage =  viewerThumbArea.getAtrribOrdemMultiPageElementSelected();

          if (fileType === 1) { // IMAGEM 
            workArea.toolbarPage.downloadTool.downloadImage(pageId, ordemMultiPage);
          }
          else if (fileType === 2) { // ARQUIVO
            if (fileExtension === 3) 
            {
              workArea.toolbarPage.downloadTool.downloadPDF();
            }
            else {
              workArea.toolbarPage.downloadTool.downloadOtherFile(pageId, ordemMultiPage, fileType, fileExtension);
            }
          }
          else if (fileType === 3) { // MULTIMIDIA
            workArea.toolbarPage.downloadTool.downloadOtherFile(pageId, ordemMultiPage, fileType, fileExtension);
          }
        });
        $left_tools_5.append($tool_download);
        return $left_tools_5;

      },

      downloadBlob: function (blobUrl) {
      
        var link = document.createElement("a");

        link.href = blobUrl;
        link.download = "liquidsuitedownload.pdf";
        link.style.display = "none";

        document.body.appendChild(link);
        link.click();
        link.remove();

        common.closeLoadingFullPage();    
      
      },

    },

    create: function (page, total) {

      workArea.element().append('<div class="liquid-page-tools"></div>');

      let $page_tools_left = $('<div class="page-tools-lef"></div>');
      $page_tools_left.append(workArea.toolbarPage.sizeTool.create());
      $page_tools_left.append(workArea.toolbarPage.definedSizeTool.create());
      workArea.toolbarPage.element().append($page_tools_left);

      let $page_tools_center = $('<div class="page-tools-center"></div>');
      $page_tools_center.append(workArea.toolbarPage.navLabelTool.create(page, total));
      workArea.toolbarPage.element().append($page_tools_center);

      let $page_tools_right = $('<div class="page-tools-right"></div>');
      $page_tools_right.append(workArea.toolbarPage.printTool.create());
      $page_tools_right.append(workArea.toolbarPage.downloadTool.create());
      workArea.toolbarPage.element().append($page_tools_right);

      // HIDE TOOLS

      workArea.toolbarPage.sizeTool.hide();

      workArea.toolbarPage.definedSizeTool.hide();

      workArea.toolbarPage.navLabelTool.hide();

      workArea.toolbarPage.printTool.hide();

      workArea.toolbarPage.downloadTool.hide();

    }
  },

  viewerPage: {

    idDOM: '#container-view',

    element: function () {

      return jQuery(workArea.viewerPage.idDOM);
    },

    clear: function () {

      workArea.viewerPage.element().empty();

    },

    loading: function () {

      workArea.viewerPage.clear();
      workArea.viewerPage.element().append(common.loading.element());

    },

    blobsPages: [],

    blobsPagesAsPDF: [],

    resize: function () {

      const hasAccessError = $('#container-view .ls-viewer-message-access-error').length > 0 || $('#container-view .ls-viewer-message-empty-document').length > 0;

      const offset = hasAccessError
        ? common.headerAndContextBarHeight
        : common.headerAndContextBarHeightAndViewerPageTools;

      const viewerPageHeight = (($(window).height()) - (offset));
      $(workArea.viewerPage.idDOM).css({ height: viewerPageHeight, width: '100%'  });

      var viewerPageHeightEmbed = (($(window).height()) - (common.headerAndContextBarHeightAndViewerPageToolsEmbed));
      $(workArea.viewerPage.idDOM + ' embed').css({ height: viewerPageHeightEmbed, width: '100%' });

      var viewerPageHeightIFrame = (($(window).height()) - (common.headerAndContextBarHeightAndViewerPageToolsEmbed));
      $(workArea.viewerPage.idDOM + ' iframe').css({ height: viewerPageHeightIFrame, width: '100%' });

    },

    create: function () {

      workArea.element().append('<div id="container-view" ></div>');

    },

    getBlobUrl: function (pageId, ordemMultiPage = null) {

      if (ordemMultiPage === null || ordemMultiPage === undefined) {

        var itemFilter = workArea.viewerPage.blobsPages.filter(function (el) {
            return el.id === parseInt(pageId);
        });

        return itemFilter.length > 0
            ? itemFilter[0].blob
            : null;
      }

      var itemFilter = workArea.viewerPage.blobsPages.filter(function (el) {
        return el.id === parseInt(pageId)
            && el.ordemMultiPage === parseInt(ordemMultiPage);
      });

      return itemFilter.length > 0
        ? itemFilter[0].blob
        : null;

    },

    getBlobObject: function (pageId, ordemMultiPage = null) {

      if (ordemMultiPage === null || ordemMultiPage === undefined) {

        var itemFilter = workArea.viewerPage.blobsPages.filter(function (el) {
            return el.id === parseInt(pageId);
        });

        return itemFilter.length > 0
            ? itemFilter[0].blobObject
            : null;
      }

      var itemFilter = workArea.viewerPage.blobsPages.filter(function (el) {
        return el.id === parseInt(pageId)
            && el.ordemMultiPage === parseInt(ordemMultiPage);
      });

      return itemFilter.length > 0
        ? itemFilter[0].blobObject
        : null;

    },

    getBlobArrayObject: function (pageId, ordemMultiPage = null) {

      if (ordemMultiPage === null || ordemMultiPage === undefined) {

        var itemFilter = workArea.viewerPage.blobsPages.filter(function (el) {
            return el.id === parseInt(pageId);
        });

        return itemFilter.length > 0
            ? itemFilter[0]
            : null;
      }

      var itemFilter = workArea.viewerPage.blobsPages.filter(function (el) {
        return el.id === parseInt(pageId)
            && el.ordemMultiPage === parseInt(ordemMultiPage);
      });

      return itemFilter.length > 0
        ? itemFilter[0]
        : null;

    },

    getBlobAsPDFArrayObject: function (pageId) {

      var itemFilter = workArea.viewerPage.blobsPagesAsPDF.filter(function (el) {
            return el.id === parseInt(pageId);
        });

      return itemFilter.length > 0
          ? itemFilter[0]
          : null;
    },

    getBlobAsPDFUrl: function (pageId, ordemMultiPage = null) {

      if (ordemMultiPage === null || ordemMultiPage === undefined) {

        var itemFilter = workArea.viewerPage.blobsPagesAsPDF.filter(function (el) {
            return el.id === parseInt(pageId);
        });

        return itemFilter.length > 0
            ? itemFilter[0].blob
            : null;
      }

      var itemFilter = workArea.viewerPage.blobsPagesAsPDF.filter(function (el) {
        return el.id === parseInt(pageId)
            && el.ordemMultiPage === parseInt(ordemMultiPage);
      });

      return itemFilter.length > 0
        ? itemFilter[0].blob
        : null;

    },

    // #region MESSAGE INFO ERROS MAIN VIEWERS

    showdocumentNoPages: function () {

      let content = `
        <div class="ls-viewer-message ls-viewer-message-empty-document">

          <div class="ls-viewer-access-icon">
              <svg viewBox="0 0 160 160" aria-hidden="true">

                  <circle cx="80" cy="78" r="58" fill="#EEF4F7"></circle>

                  <circle cx="80" cy="78" r="68"
                          fill="none"
                          stroke="#D6E3E8"
                          stroke-width="2"
                          stroke-dasharray="8 8"/>

                  <path d="M52 28h46l30 30v70a8 8 0 0 1-8 8H52a8 8 0 0 1-8-8V36a8 8 0 0 1 8-8z"
                        fill="#FFFFFF"
                        stroke="#8E9AA3"
                        stroke-width="4"/>

                  <path d="M98 28v30h30"
                        fill="#E5E7EA"/>

                  <rect x="63" y="76" width="52" height="7" rx="3.5" fill="#C3C8CD"/>
                  <rect x="63" y="94" width="42" height="7" rx="3.5" fill="#C3C8CD"/>
                  <rect x="63" y="112" width="34" height="7" rx="3.5" fill="#C3C8CD"/>

                  <!-- símbolo vazio -->
                  <circle cx="112" cy="112" r="24"
                          fill="#90A4AE"/>

                  <path d="M101 112h22"
                        stroke="#FFFFFF"
                        stroke-width="6"
                        stroke-linecap="round"/>
              </svg>
          </div>

          <h2>Este documento não possui arquivos</h2>

          <p class="ls-viewer-message-subtitle">
              Não existem páginas ou arquivos disponíveis para visualização neste documento.
          </p>

          <p class="ls-viewer-message-description">
              O documento pode estar vazio ou os arquivos ainda não foram adicionados.
          </p>

          <div class="ls-viewer-error-box ls-viewer-info-box">

              <div class="ls-viewer-error-icon ls-viewer-info-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                      <circle cx="12" cy="12" r="9"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"/>

                      <path d="M12 10v7"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"/>

                      <circle cx="12" cy="7"
                              r="1.3"
                              fill="currentColor"/>
                  </svg>
              </div>

              <div>
                  <strong>Informações adicionais</strong>

                  <p>
                      Caso você esperasse visualizar arquivos neste documento,
                      entre em contato com o responsável pelo compartilhamento
                      ou com o administrador do sistema.
                  </p>
              </div>

          </div>

        </div>
      `;

      workArea.viewerPage.create();

      let $content = $(content);

      viewerThumbArea.hide();
      workArea.toolbarPage.hide();

      workArea.viewerPage.clear();
      workArea.viewerPage.resize();
      workArea.viewerPage.element().append($content);
      workArea.viewerPage.resize();
    },

    showLoadPageError: function (errorMessage) {

      let content = `
        <div class="ls-viewer-message ls-viewer-message-access-error">

          <div class="ls-viewer-access-icon">
              <svg viewBox="0 0 160 160" aria-hidden="true">
                  <circle cx="80" cy="78" r="58" fill="#FDEAEA"></circle>
                  <circle cx="80" cy="78" r="68" fill="none" stroke="#F5B5B5" stroke-width="2" stroke-dasharray="8 8"/>

                  <rect x="50" y="70" width="60" height="48" rx="8"
                        fill="#FFFFFF" stroke="#7A858C" stroke-width="5"/>

                  <path d="M60 70V54c0-20 40-20 40 0v16"
                        fill="none" stroke="#7A858C" stroke-width="6" stroke-linecap="round"/>

                  <circle cx="80" cy="92" r="7" fill="#7A858C"/>
                  <path d="M80 98v10" stroke="#7A858C" stroke-width="5" stroke-linecap="round"/>

                  <circle cx="113" cy="106" r="27" fill="#E53935"/>
                  <path d="M113 90v21" stroke="#FFFFFF" stroke-width="7" stroke-linecap="round"/>
                  <circle cx="113" cy="121" r="4" fill="#FFFFFF"/>
              </svg>
          </div>

          <h2>Não foi possível abrir o visualizador</h2>

          <p class="ls-viewer-message-subtitle">
              O link de acesso expirou ou não é mais válido.
          </p>

          <p class="ls-viewer-message-description">
              Solicite um novo link de acesso ou abra o documento novamente pelo sistema de origem.
          </p>

          <div class="ls-viewer-error-box">
              <div class="ls-viewer-error-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2"/>
                      <path d="M12 7v7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                      <circle cx="12" cy="17" r="1.3" fill="currentColor"/>
                  </svg>
              </div>

              <div>
                  <strong>Detalhes do erro</strong>
                  <p>
                      ${errorMessage}<br>
                      Por segurança, o acesso ao documento foi bloqueado.
                  </p>
              </div>
          </div>

          <div class="ls-viewer-help">
              <div class="ls-viewer-help-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2"/>
                      <path d="M12 10v7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                      <circle cx="12" cy="7" r="1.3" fill="currentColor"/>
                  </svg>
              </div>

              <span>
                  Se você acredita que isso é um engano,<br>
                  entre em contato com o responsável pelo compartilhamento ou com o administrador do sistema.
              </span>
          </div>

        </div>
      `;

      workArea.viewerPage.create();

      let $content = $(content);

      viewerThumbArea.hide();
      workArea.toolbarPage.hide();

      workArea.viewerPage.clear();
      workArea.viewerPage.resize();
      workArea.viewerPage.element().append($content);
      workArea.viewerPage.resize();
    },

    //#endregion

    // #region MESSAGE INFO ERROS VIEWERS

    createFileNotDisplayViewer: function (pageId, ordemMultiPage, fileType, fileExtension) {

      let downloadArea = '';
      let infoArea = '';

      if (workArea.canDownload()) {

          downloadArea = `
              <button type="button" class="ls-viewer-download-button">
                <span class="ls-viewer-download-icon">

                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M12 4v10"
                              stroke="currentColor"
                              stroke-width="2.2"
                              stroke-linecap="round"/>

                        <path d="M8 11l4 4 4-4"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2.2"
                              stroke-linecap="round"
                              stroke-linejoin="round"/>

                        <path d="M5 19h14"
                              stroke="currentColor"
                              stroke-width="2.2"
                              stroke-linecap="round"/>
                    </svg>

                </span>

                <span>Baixar arquivo</span>
            </button>
          `;

          infoArea = `
            <span>
                Você pode fazer o download e abrir este arquivo<br>
                no programa de sua preferência.
            </span>
          `;

      }
      else {

          downloadArea = `
              <div class="ls-viewer-download-disabled-container">

                <button type="button"
                        class="ls-viewer-download-button ls-viewer-download-button-disabled"
                        disabled>

                    <span class="ls-viewer-download-icon">

                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M12 4v10"
                                  stroke="currentColor"
                                  stroke-width="2.2"
                                  stroke-linecap="round"/>

                            <path d="M8 11l4 4 4-4"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2.2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"/>

                            <path d="M5 19h14"
                                  stroke="currentColor"
                                  stroke-width="2.2"
                                  stroke-linecap="round"/>
                        </svg>

                    </span>

                    <span>Download indisponível</span>
                </button>

                <div class="ls-viewer-download-disabled-message">
                    Você não possui permissão para baixar este arquivo.
                </div>

            </div>
          `;

          infoArea = `
            <span>
                Entre em contato com o responsável pelo compartilhamento ou com o administrador do sistema para solicitar acesso ao arquivo.
            </span>
          `;
      }

      let content = `
        <div class="ls-viewer-message ls-viewer-message-unavailable">

            <div class="ls-viewer-icon">
                <!-- Ícone: arquivo sem visualização -->
                <svg viewBox="0 0 160 160" aria-hidden="true">
                    <circle cx="80" cy="78" r="58" fill="#EEF4F7"></circle>

                    <path d="M52 28h46l30 30v70a8 8 0 0 1-8 8H52a8 8 0 0 1-8-8V36a8 8 0 0 1 8-8z"
                          fill="#FFFFFF"
                          stroke="#C8CDD2"
                          stroke-width="4"/>

                    <path d="M98 28v30h30"
                          fill="#E5E7EA"/>

                    <rect x="63" y="76" width="52" height="7" rx="3.5" fill="#B7BBC0"/>
                    <rect x="63" y="94" width="42" height="7" rx="3.5" fill="#B7BBC0"/>
                    <rect x="63" y="112" width="34" height="7" rx="3.5" fill="#B7BBC0"/>

                    <circle cx="112" cy="112" r="27"
                            fill="none"
                            stroke="#2F8395"
                            stroke-width="7"/>

                    <path d="M94 94l36 36"
                          stroke="#2F8395"
                          stroke-width="7"
                          stroke-linecap="round"/>
                </svg>
            </div>

            <h2>Este arquivo não pode ser visualizado aqui</h2>

            <p class="ls-viewer-message-subtitle">
                Este tipo de arquivo não possui visualização direta no navegador.
            </p>

            <p class="ls-viewer-message-description">
                Você pode baixar o arquivo para abrir no aplicativo apropriado.
            </p>

            ${downloadArea}

            <div class="ls-viewer-help">
                <div class="ls-viewer-help-icon">
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <circle cx="12" cy="12" r="9"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"/>

                        <path d="M12 10v7"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"/>

                        <circle cx="12" cy="7"
                                r="1.3"
                                fill="currentColor"/>
                    </svg>
                </div>

                ${infoArea}
            </div>

        </div>
      `;

      let $content = $(content);

      if (workArea.canDownload()) {
        $content.find('.ls-viewer-download-button').on('click', function () {
          workArea.toolbarPage.downloadTool.downloadOtherFile(pageId, ordemMultiPage, fileType, fileExtension);
        });
      }

      workArea.viewerPage.clear();
      workArea.viewerPage.resize();
      workArea.viewerPage.element().append($content);
      workArea.viewerPage.resize();

      workArea.toolbarPage.sizeTool.hide();
      workArea.toolbarPage.definedSizeTool.hide();
      workArea.toolbarPage.navLabelTool.show();
      workArea.toolbarPage.printTool.hide();
      workArea.toolbarPage.downloadTool.hide();
      if (workArea.canDownload()) {
        workArea.toolbarPage.downloadTool.show();
      }

    },

    createFileTooLargeViewer: function (pageId, ordemMultiPage, fileType, fileExtension) {

      let downloadArea = '';
      let infoArea = '';

      if (workArea.canDownload()) {

          downloadArea = `
              <button type="button" class="ls-viewer-download-button">
                <span class="ls-viewer-download-icon">

                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M12 4v10"
                              stroke="currentColor"
                              stroke-width="2.2"
                              stroke-linecap="round"/>

                        <path d="M8 11l4 4 4-4"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2.2"
                              stroke-linecap="round"
                              stroke-linejoin="round"/>

                        <path d="M5 19h14"
                              stroke="currentColor"
                              stroke-width="2.2"
                              stroke-linecap="round"/>
                    </svg>

                </span>

                <span>Baixar arquivo</span>
            </button>
          `;

          infoArea = `
            <span>
               Arquivos muito grandes podem deixar o navegador lento ou impedir a abertura correta da visualização.
            </span>
          `;

      }
      else {

          downloadArea = `
              <div class="ls-viewer-download-disabled-container">

                <button type="button"
                        class="ls-viewer-download-button ls-viewer-download-button-disabled"
                        disabled>

                    <span class="ls-viewer-download-icon">

                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M12 4v10"
                                  stroke="currentColor"
                                  stroke-width="2.2"
                                  stroke-linecap="round"/>

                            <path d="M8 11l4 4 4-4"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2.2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"/>

                            <path d="M5 19h14"
                                  stroke="currentColor"
                                  stroke-width="2.2"
                                  stroke-linecap="round"/>
                        </svg>

                    </span>

                    <span>Download indisponível</span>
                </button>

                <div class="ls-viewer-download-disabled-message">
                    Você não possui permissão para baixar este arquivo.
                </div>

            </div>
          `;

          infoArea = `
            <span>
                Entre em contato com o responsável pelo compartilhamento ou com o administrador do sistema para solicitar acesso ao arquivo.
            </span>
          `;
      }

      let content = `
        <div class="ls-viewer-message ls-viewer-message-file-too-large">

          <div class="ls-viewer-icon">
              <svg viewBox="0 0 160 160" aria-hidden="true">
                  <circle cx="80" cy="78" r="58" fill="#EEF4F7"></circle>

                  <path d="M52 28h46l30 30v70a8 8 0 0 1-8 8H52a8 8 0 0 1-8-8V36a8 8 0 0 1 8-8z"
                        fill="#FFFFFF" stroke="#C8CDD2" stroke-width="4"/>

                  <path d="M98 28v30h30" fill="#E5E7EA"/>

                  <rect x="63" y="76" width="52" height="7" rx="3.5" fill="#B7BBC0"/>
                  <rect x="63" y="94" width="42" height="7" rx="3.5" fill="#B7BBC0"/>
                  <rect x="63" y="112" width="34" height="7" rx="3.5" fill="#B7BBC0"/>

                  <circle cx="112" cy="112" r="27" fill="#F39C12"/>
                  <path d="M112 96v21" stroke="#FFFFFF" stroke-width="7" stroke-linecap="round"/>
                  <circle cx="112" cy="127" r="4" fill="#FFFFFF"/>
              </svg>
          </div>

          <h2>Este arquivo é muito grande para ser visualizado aqui</h2>

          <p class="ls-viewer-message-subtitle">
              O tamanho deste arquivo excede o limite recomendado para visualização direta no navegador.
          </p>

          <p class="ls-viewer-message-description">
              Você pode baixar o arquivo para abrir no aplicativo apropriado.
          </p>

          ${downloadArea}

          <div class="ls-viewer-help">
              <div class="ls-viewer-help-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2"/>
                      <path d="M12 10v7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                      <circle cx="12" cy="7" r="1.3" fill="currentColor"/>
                  </svg>
              </div>

              ${infoArea}
          </div>

        </div>
      `;

      let $content = $(content);

      if (workArea.canDownload()) {
        $content.find('.ls-viewer-download-button').on('click', function () {
          workArea.toolbarPage.downloadTool.downloadOtherFile(pageId, ordemMultiPage, fileType, fileExtension);
        });
      }

      workArea.viewerPage.clear();
      workArea.viewerPage.resize();
      workArea.viewerPage.element().append($content);
      workArea.viewerPage.resize();

      workArea.toolbarPage.sizeTool.hide();
      workArea.toolbarPage.definedSizeTool.hide();
      workArea.toolbarPage.navLabelTool.show();
      workArea.toolbarPage.printTool.hide();
      workArea.toolbarPage.downloadTool.hide();
      if (workArea.canDownload()) {
        workArea.toolbarPage.downloadTool.show();
      }

    },

    createFileErrorViewer: function (pageId, ordemMultiPage) {

      let blobArrayObj = workArea.viewerPage.getBlobArrayObject(pageId, ordemMultiPage);

      let errorMessage = 'Não foi possivel obter a mensagem de erro';

      if (blobArrayObj !== null) {
        errorMessage = common.getErrorMessage(blobArrayObj.errorDetails);
      }

      let content = `
        <div class="ls-viewer-message ls-viewer-message-error">

          <div class="ls-viewer-icon">
              <!-- Ícone: arquivo com erro -->
              <svg viewBox="0 0 160 160" aria-hidden="true">
                  <circle cx="80" cy="78" r="58" fill="#FDEAEA"></circle>

                  <path d="M52 28h46l30 30v70a8 8 0 0 1-8 8H52a8 8 0 0 1-8-8V36a8 8 0 0 1 8-8z"
                        fill="#FFFFFF"
                        stroke="#C8CDD2"
                        stroke-width="4"/>

                  <path d="M98 28v30h30"
                        fill="#E5E7EA"/>

                  <rect x="63" y="76" width="52" height="7" rx="3.5" fill="#B7BBC0"/>
                  <rect x="63" y="94" width="42" height="7" rx="3.5" fill="#B7BBC0"/>
                  <rect x="63" y="112" width="34" height="7" rx="3.5" fill="#B7BBC0"/>

                  <circle cx="112" cy="112" r="28" fill="#E53935"/>
                  <path d="M112 96v21" stroke="#FFFFFF" stroke-width="7" stroke-linecap="round"/>
                  <circle cx="112" cy="127" r="4" fill="#FFFFFF"/>
              </svg>
          </div>

          <h2>Não foi possível carregar o arquivo</h2>

          <p class="ls-viewer-message-subtitle">
              Não foi possível recuperar o arquivo solicitado.
          </p>

          <div class="ls-viewer-error-box">
              <div class="ls-viewer-error-icon">
                  <!-- Ícone: informação/erro -->
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2"/>
                      <path d="M12 10v7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                      <circle cx="12" cy="7" r="1.3" fill="currentColor"/>
                  </svg>
              </div>

              <div>
                  <strong>Detalhes do erro</strong>
                  <p>
                      ${errorMessage}
                  </p>
              </div>
          </div>

          <div class="ls-viewer-help">
              <div class="ls-viewer-help-icon">
                  <!-- Ícone: informação -->
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2"/>
                      <path d="M12 10v7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                      <circle cx="12" cy="7" r="1.3" fill="currentColor"/>
                  </svg>
              </div>

              <span>
                  Se você acredita que isso é um engano,<br>
                  entre em contato com o administrador do sistema.
              </span>
          </div>

        </div>
      `;

      let $content = $(content);

      workArea.viewerPage.clear();
      workArea.viewerPage.resize();
      workArea.viewerPage.element().append($content);
      workArea.viewerPage.resize();

      workArea.toolbarPage.sizeTool.hide();
      workArea.toolbarPage.definedSizeTool.hide();
      workArea.toolbarPage.navLabelTool.show();
      workArea.toolbarPage.printTool.hide();
      workArea.toolbarPage.downloadTool.hide();

    },

    createFileViewAsPDFErrorViewer: function (pageId, fileType, fileExtension) {

      let blobArrayObj = workArea.viewerPage.getBlobAsPDFArrayObject(pageId);

      let errorMessage = 'Não foi possivel obter a mensagem de erro';

      if (blobArrayObj !== null) {
        errorMessage = common.getErrorMessage(blobArrayObj.errorDetails);
      }

      let downloadArea = '';

      if (workArea.canDownload()) {

          downloadArea = `
              <button type="button" class="ls-viewer-download-button">
                <span class="ls-viewer-download-icon">

                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M12 4v10"
                              stroke="currentColor"
                              stroke-width="2.2"
                              stroke-linecap="round"/>

                        <path d="M8 11l4 4 4-4"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2.2"
                              stroke-linecap="round"
                              stroke-linejoin="round"/>

                        <path d="M5 19h14"
                              stroke="currentColor"
                              stroke-width="2.2"
                              stroke-linecap="round"/>
                    </svg>

                </span>

                <span>Baixar arquivo</span>
            </button>
          `;

      }
      else {

          downloadArea = `
              <div class="ls-viewer-download-disabled-container">

                <button type="button"
                        class="ls-viewer-download-button ls-viewer-download-button-disabled"
                        disabled>

                    <span class="ls-viewer-download-icon">

                        <svg viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M12 4v10"
                                  stroke="currentColor"
                                  stroke-width="2.2"
                                  stroke-linecap="round"/>

                            <path d="M8 11l4 4 4-4"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2.2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"/>

                            <path d="M5 19h14"
                                  stroke="currentColor"
                                  stroke-width="2.2"
                                  stroke-linecap="round"/>
                        </svg>

                    </span>

                    <span>Download indisponível</span>
                </button>

                <div class="ls-viewer-download-disabled-message">
                    Você não possui permissão para baixar este arquivo.
                </div>

            </div>
          `;

      }

      let content = `
        <div class="ls-viewer-message ls-viewer-message-error">

          <div class="ls-viewer-icon">
              <!-- Ícone: arquivo com erro -->
              <svg viewBox="0 0 160 160" aria-hidden="true">
                  <circle cx="80" cy="78" r="58" fill="#FDEAEA"></circle>

                  <path d="M52 28h46l30 30v70a8 8 0 0 1-8 8H52a8 8 0 0 1-8-8V36a8 8 0 0 1 8-8z"
                        fill="#FFFFFF"
                        stroke="#C8CDD2"
                        stroke-width="4"/>

                  <path d="M98 28v30h30"
                        fill="#E5E7EA"/>

                  <rect x="63" y="76" width="52" height="7" rx="3.5" fill="#B7BBC0"/>
                  <rect x="63" y="94" width="42" height="7" rx="3.5" fill="#B7BBC0"/>
                  <rect x="63" y="112" width="34" height="7" rx="3.5" fill="#B7BBC0"/>

                  <circle cx="112" cy="112" r="28" fill="#E53935"/>
                  <path d="M112 96v21" stroke="#FFFFFF" stroke-width="7" stroke-linecap="round"/>
                  <circle cx="112" cy="127" r="4" fill="#FFFFFF"/>
              </svg>
          </div>

          <h2>Não foi possível gerar a visualização em PDF deste arquivo</h2>

          <p class="ls-viewer-message-subtitle">
              Não doi possível obter o PDF deste arquivo.
          </p>

          <div class="ls-viewer-error-box">
              <div class="ls-viewer-error-icon">
                  <!-- Ícone: informação/erro -->
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2"/>
                      <path d="M12 10v7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                      <circle cx="12" cy="7" r="1.3" fill="currentColor"/>
                  </svg>
              </div>

              <div>
                  <strong>Detalhes do erro</strong>
                  <p>
                      ${errorMessage}
                  </p>
              </div>
          </div>

          <p class="ls-viewer-message-description">
              Você pode baixar o arquivo para abrir no aplicativo apropriado.
          </p>

          ${downloadArea}

          <div class="ls-viewer-help">
              <div class="ls-viewer-help-icon">
                  <!-- Ícone: informação -->
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2"/>
                      <path d="M12 10v7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                      <circle cx="12" cy="7" r="1.3" fill="currentColor"/>
                  </svg>
              </div>

              <span>
                  Se você acredita que isso é um engano,<br>
                  entre em contato com o administrador do sistema.
              </span>
          </div>

        </div>
      `;

      let $content = $(content);

      if (workArea.canDownload()) {
        $content.find('.ls-viewer-download-button').on('click', function () {
          workArea.toolbarPage.downloadTool.downloadOtherFile(pageId, ordemMultiPage, fileType, fileExtension);
        });
      }

      workArea.viewerPage.clear();
      workArea.viewerPage.resize();
      workArea.viewerPage.element().append($content);
      workArea.viewerPage.resize();

      workArea.toolbarPage.sizeTool.hide();
      workArea.toolbarPage.definedSizeTool.hide();
      workArea.toolbarPage.navLabelTool.show();
      workArea.toolbarPage.printTool.hide();
      workArea.toolbarPage.downloadTool.hide();
      if (workArea.canDownload()) {
        workArea.toolbarPage.downloadTool.show();
      }

    },

    // #endregion

    // #region IMAGEM VIEWERS

    createImagemViewer: function (cssImage, scrURLBlob) {

      var element = document.createElement("img");
      element.src = scrURLBlob;
      element.id = 'imageViewerFrame';
      element.setAttribute('type', 'image/jpeg');

      element.addEventListener('contextmenu', function (e) {
          e.preventDefault();
          return false;
      });

      if (cssImage !== null) {
        element.style.cssText = cssImage;
      }
      else {
        element.style.cssText = 'width: 100%; height: auto;'; // DEFAULT FIT HORIZONTAL
      }
      var $containerViewImagem = $('<div class="container-view-image"></div>');
      $containerViewImagem.append(element);

      workArea.viewerPage.clear();
      workArea.viewerPage.resize();
      workArea.viewerPage.element().append($containerViewImagem);
      workArea.viewerPage.resize();

      workArea.toolbarPage.sizeTool.show();
      workArea.toolbarPage.definedSizeTool.show();
      workArea.toolbarPage.navLabelTool.show();
      workArea.toolbarPage.printTool.hide();
      workArea.toolbarPage.downloadTool.hide();

      if (workArea.canPrint()) {
        workArea.toolbarPage.printTool.show();
      }
      if (workArea.canDownload()) {
        workArea.toolbarPage.downloadTool.show();
      }

    },

    // #endregion

    // #region ARQUIVO VIEWERS

    createPDFViewer: function (scrURLBlob, isRangeAccess) {
      if (window.lsViewerConfig && window.lsViewerConfig.usePdfJs) {

        var element = document.createElement("iframe");

        element.id = "pdfjsViewerFrame";

        const viewerUrl = utils.getPdfJsViewerUrl();

        if (isRangeAccess) {
          var fileUrl = new URL(scrURLBlob, window.location.origin).href;
          element.src = viewerUrl + "?file=" + encodeURIComponent(fileUrl);
        }
        else {
          element.src = viewerUrl + "?file=" + encodeURIComponent(scrURLBlob);
        }

        var viewerPageHeightEmbed = (($(window).height()) - (common.headerAndContextBarHeightAndViewerPageToolsEmbed));

        element.style.cssText = 'width: 100%; height: ' + viewerPageHeightEmbed + 'px; border: none;';

        let $containerViewImagem = $('<div class="container-view-image"></div>');
        $containerViewImagem.append(element);

        workArea.viewerPage.clear();
        workArea.viewerPage.resize();
        workArea.viewerPage.element().append($containerViewImagem);
        workArea.viewerPage.resize();
      } else {
        var element = document.createElement("embed");
        element.id = "embedViewerFrame";
        element.src = scrURLBlob;
        element.setAttribute('type', 'application/pdf');

        var viewerPageHeightEmbed = (($(window).height()) - (common.headerAndContextBarHeightAndViewerPageToolsEmbed));
        element.style.cssText = 'width: 100%; height: ' + viewerPageHeightEmbed + 'px;'; // DEFAULT FIT HORIZONTAL

        let $containerViewImagem = $('<div class="container-view-image"></div>');
        $containerViewImagem.append(element);
        workArea.viewerPage.clear();
        workArea.viewerPage.resize();
        workArea.viewerPage.element().append($containerViewImagem);
        workArea.viewerPage.resize();
      }

      workArea.toolbarPage.sizeTool.hide();
      workArea.toolbarPage.definedSizeTool.hide();
      workArea.toolbarPage.navLabelTool.show();
      workArea.toolbarPage.printTool.hide();
      workArea.toolbarPage.downloadTool.hide();
      
      if (workArea.canPrint()) {
        workArea.toolbarPage.printTool.show();
      }
      if (workArea.canDownload()) {
        workArea.toolbarPage.downloadTool.show();
      }
        
    },

    createFileAsPDFViewer: function (pageId, fileExtension) {

      var blobArrayAsPDFObj =  workArea.viewerPage.getBlobAsPDFArrayObject(pageId);

      if (blobArrayAsPDFObj === null) {

        var blobArrayObj =  workArea.viewerPage.getBlobArrayObject(pageId);

        var extension = utils.getExtensionFromMimeType(blobArrayObj.blobObject.type);

        var formData = new FormData();
        var fileName = `arquivo.${extension}`;
        formData.append('file', blobArrayObj.blobObject, fileName);
        formData.append('token', window.lsViewerToken);

        viewerService.postConvertPageAsPDFFile(formData)
          .then((blob) => {
            
            var URL = window.URL || window.webkitURL;
            var srcUrl = URL.createObjectURL(blob);

            workArea.viewerPage.blobsPagesAsPDF.push(
            {
              id: parseInt(pageId),
              blob: srcUrl,
              ordemMultiPage: 1,
              blobObject: blob,
              success: true,
              errorDetails: null
            });

            workArea.viewerPage.createPDFViewer(srcUrl, false);

            notify.alert('Atenção', 'Você esta vendo uma visualização em PDF do arquivo original pois o mesmo não pode ser exibido no navegador web');

          }).catch((failData) => {

            workArea.viewerPage.blobsPagesAsPDF.push(
            {
              id: parseInt(pageId),
              blob: null,
              ordemMultiPage: 1,
              blobObject: null,
              success: false,
              errorDetails: failData
            });

            workArea.viewerPage.createFileViewAsPDFErrorViewer(pageId, 2, fileExtension);

          });
      
      }
      else {

        if (blobArrayAsPDFObj.success) {
          
          workArea.viewerPage.createPDFViewer(blobArrayAsPDFObj.blob, false);
          notify.alert('Atenção', 'Você esta vendo uma visualização em PDF do arquivo original pois o mesmo não pode ser exibido no navegador web');
        
        }
        else {

          workArea.viewerPage.createFileViewAsPDFErrorViewer(pageId, 2, fileExtension);

        }
      }
     
    },

    // #endregion

    // #region MULTIMIDIA VIEWERS
    
    createVideoViewer: function (scrURLBlob, extensao) {

      var element = document.createElement("video");

      element.id = "videoViewerFrame";
      element.src = scrURLBlob;
      element.controls = true;
      element.className = 'ls-video-element';

      var mimeType = utils.getMultimidiaMimeTypeByExtensaoLiquidSuite(parseInt(extensao));

      element.setAttribute('type', mimeType);
      element.controlsList = 'nodownload';

      element.onerror = function () {

          var errorMessage = utils.getMediaErrorMessage(element);

          element.pause();
          element.style.pointerEvents = 'none';
          element.style.opacity = '0.4';
          element.removeAttribute('controls');
          element.classList.add('ls-media-error');

          var parent = element.parentElement;

          if (!parent) {
              return;
          }

          if (parent.querySelector('.ls-media-error-overlay')) {
              return;
          }

          var overlay = document.createElement('div');
          overlay.className = 'ls-media-error-overlay';

          overlay.innerHTML = `
              <div class="ls-media-error-content">
                  <div class="ls-media-error-icon">
                      <i class="fa fa-exclamation-triangle"></i>
                  </div>

                  <div class="ls-media-error-title">
                      Não foi possível carregar o arquivo
                  </div>

                  <div class="ls-media-error-message">
                      ${errorMessage}
                  </div>
              </div>
          `;

          parent.appendChild(overlay);
      };

      var $containerViewVideo = $('<div class="ls-media-viewer ls-video-viewer"></div>');
      $containerViewVideo.css('position', 'relative');
      $containerViewVideo.append(element);

      workArea.viewerPage.clear();
      workArea.viewerPage.resize();
      workArea.viewerPage.element().append($containerViewVideo);
      workArea.viewerPage.resize();

      workArea.toolbarPage.sizeTool.hide();
      workArea.toolbarPage.definedSizeTool.hide();
      workArea.toolbarPage.navLabelTool.show();
      workArea.toolbarPage.printTool.hide();
      workArea.toolbarPage.downloadTool.hide();

      if (workArea.canDownload()) {
        workArea.toolbarPage.downloadTool.show();
      }
      
    },

    createAudioViewer: function (scrURLBlob, extensao) {

      var element = document.createElement("audio");

      element.id = "audioViewerFrame";
      element.src = scrURLBlob;
      element.controls = true;
      element.className = 'ls-audio-element';

      var mimeType = utils.getMultimidiaMimeTypeByExtensaoLiquidSuite(parseInt(extensao));

      element.setAttribute('type', mimeType);
      element.controlsList = 'nodownload';

      element.onerror = function () {

        var errorMessage = utils.getMediaErrorMessage(element);

        element.pause();

        element.style.pointerEvents = 'none';
        element.style.opacity = '0.4';

        element.removeAttribute('controls');

        var parentCard = element.closest('.ls-audio-card');

        if (parentCard) {

            var description = parentCard.querySelector('p');

            if (description) {
                description.innerHTML = errorMessage;
            }

            parentCard.classList.add('ls-audio-error');
        }

        notify.danger(
            'Não foi possível carregar o arquivo',
            errorMessage,
            true
        );
      };

      var $containerViewAudioCard = $('<div class="ls-audio-card"></div>');
      $containerViewAudioCard.append('<div class="ls-audio-icon">🎵</div>');
      $containerViewAudioCard.append('<h2>Arquivo de áudio</h2>');
      $containerViewAudioCard.append('<p>Use o player abaixo para reproduzir o arquivo.</p>');
      $containerViewAudioCard.append(element);

      var $containerViewAudio = $('<div class="ls-media-viewer"></div>');
      $containerViewAudio.append($containerViewAudioCard);

      workArea.viewerPage.clear();
      workArea.viewerPage.resize();
      workArea.viewerPage.element().append($containerViewAudio);
      workArea.viewerPage.resize();

      workArea.toolbarPage.sizeTool.hide();
      workArea.toolbarPage.definedSizeTool.hide();
      workArea.toolbarPage.navLabelTool.show();
      workArea.toolbarPage.printTool.hide();
      workArea.toolbarPage.downloadTool.hide();

      if (workArea.canDownload()) {
        workArea.toolbarPage.downloadTool.show();
      }
      
    },

    // #endregion

    // -------

    loadImagem: function (pageId, ordemMultiPage, isMultiPage) {

      var $container = workArea.element();

      var cssImage = null;
      if ($container.find('.container-view-image img').length > 0) {
        cssImage = $container.find('.container-view-image img').attr('style');
      }

      workArea.viewerPage.clear();

      workArea.viewerPage.loading();

      // GET BLOB URL
      var blobArrayObj =  workArea.viewerPage.getBlobArrayObject(pageId, ordemMultiPage);
      if (blobArrayObj === null || !blobArrayObj.success) {

        // EXIBIR ERRO
        workArea.viewerPage.createFileErrorViewer(pageId, ordemMultiPage);

      }
      else {

        workArea.viewerPage.createImagemViewer(cssImage, blobArrayObj.blob);

      }

    },

    loadArquivo: function (pageId, extensao) {

      let $container = workArea.element();

      workArea.viewerPage.clear();

      workArea.viewerPage.loading();

      // GET BLOB URL
      var blobArrayObj =  workArea.viewerPage.getBlobArrayObject(pageId);

      if (blobArrayObj === null || !blobArrayObj.success) {

        // SHOW ERROR
        workArea.viewerPage.createFileErrorViewer(pageId, 1);

      }
      else {
        if (extensao === 3) {
          workArea.viewerPage.createPDFViewer(blobArrayObj.blob, blobArrayObj.isRangeAccess);
        }
        else {
          const canShowAsPDF = new Set([1, 2, 4, 5, 7, 8, 11, 12, 16, 17, 23 ]);
          if (canShowAsPDF.has(extensao) && lsViewerConfig && lsViewerConfig.showArquivosAsPDF) {
            if (blobArrayObj.isRangeAccess) {
              workArea.viewerPage.createFileTooLargeViewer(pageId, 1, 2, extensao);
            } else {
              workArea.viewerPage.createFileAsPDFViewer(pageId, extensao);
            }
          }
          else {
            workArea.viewerPage.createFileNotDisplayViewer(pageId, 1, 2, extensao);
          }
        }
      }
    },

    loadMultimidia: function (pageId, extensao) {

      var $container = workArea.element();

      workArea.viewerPage.clear();

      workArea.viewerPage.loading();

      // GET BLOB URL
      var blobArrayObj =  workArea.viewerPage.getBlobArrayObject(pageId);

      if (blobArrayObj === null || !blobArrayObj.success) {

        // EXIBIR ERRO
        workArea.viewerPage.createFileErrorViewer(pageId, 1);

      }
      else {

        if (extensao > 4) {
          workArea.viewerPage.createVideoViewer(blobArrayObj.blob, extensao);
        }
        else {
          workArea.viewerPage.createAudioViewer(blobArrayObj.blob, extensao);
        }

      }

    },

    // -------

  },

  loadPage: function (id, tipo, extensao, isMultiPage, ordemMultiPage) {

    if (parseInt(tipo) === 1) {

      // IMAGE
      workArea.viewerPage.loadImagem(id, ordemMultiPage, isMultiPage);

    }
    else if (parseInt(tipo) === 2) {

      workArea.viewerPage.loadArquivo(id, extensao);

    }
    else if (parseInt(tipo) === 3) {

      // MULTIMIDIA
      workArea.viewerPage.loadMultimidia(id, extensao);
    }

  },

  createContainers: function (page, total) {

    workArea.clear();

    workArea.toolbarPage.create(page, total);

    workArea.viewerPage.create();

  },

  loadPageBlob: function (pageId, ordemMultiPage, pageSize) {

    const MAX_BLOB_SIZE = 300 * 1024 * 1024; // 300 MB

    const pageIdInt = parseInt(pageId);
    const ordemInt = parseInt(ordemMultiPage);
    const pageSizeNumber = Number(pageSize || 0);

    const payload = {
        id: pageId,
        ordem: ordemMultiPage,
        download: false,
        marcacoes: true,
        token: window.lsViewerToken
    };

    if (pageSizeNumber > MAX_BLOB_SIZE) {

        const rangeUrl = viewerService.getPageFileUrl(payload);

        workArea.viewerPage.blobsPages.push({
            id: pageIdInt,
            blob: rangeUrl,
            ordemMultiPage: ordemInt,
            blobObject: null,
            success: true,
            errorDetails: null,
            isRangeAccess: true
        });

        viewerThumbArea.setAtrribLoadedElemet(pageId, ordemMultiPage);
        return;
    }

    viewerService.getPageFile(payload)
      .then((blob) => {
        
        var URL = window.URL || window.webkitURL;
        var srcUrl = URL.createObjectURL(blob);

        workArea.viewerPage.blobsPages.push(
        {
          id: pageIdInt,
          blob: srcUrl,
          ordemMultiPage: ordemInt,
          blobObject: blob,
          success: true,
          errorDetails: null,
          isRangeAccess: false
        });

        viewerThumbArea.setAtrribLoadedElemet(pageId, ordemMultiPage);

      }).catch((failData) => {

        workArea.viewerPage.blobsPages.push(
        {
          id: pageIdInt,
          blob: null,
          ordemMultiPage: ordemInt,
          blobObject: null,
          success: false,
          errorDetails: failData,
          isRangeAccess: false
        });

        viewerThumbArea.setAtrribLoadedElemet(pageId, ordemMultiPage);

      });
  },

  // ----

  canDownload: function () {

    if (lsViewerConfig && lsViewerConfig.docViewPermissions) {
      return lsViewerConfig.docViewPermissions.canDownload || lsViewerConfig.sharedViewDefaultDownloadPermisision;
    }
    return true;
    
  },

  canPrint: function () {

    if (lsViewerConfig && lsViewerConfig.docViewPermissions) {
      return lsViewerConfig.docViewPermissions.canPrint || lsViewerConfig.sharedViewDefaultPrintPermisision;
    }
    return true;
    
  },


};
